<script>
import DeliveryTargetFilterObj from '@views/NotificationAgentAdmin/form/delivery-target-filter-obj.vue'
import { cloneDeep } from 'lodash'
import { FULL_ROLE_AGENT_EDIT } from '@utils/helpers'
import store from '@state/store'

export default {
  components: {
    DeliveryTargetFilterObj,
  },
  props: {
    type: {
      validator: function(value) {
        return !!~['add', 'view', 'edit'].indexOf(value)
      },
      default: 'add',
    },
    triggerMask: {
      type: Boolean,
      require: false,
    },
    errors: {
      type: Object,
      default: () => {},
    },
    notificationDetail: {
      type: Object,
      default: () => {
        return {
          filter_obj: null,
          filter_obj_flag: '0',
        }
      },
    },
  },
  data() {
    return {
      currentUser: store.getters['auth/getCurrentUser'],
      editable: false,
      data: {
        filter_obj: null,
        filter_obj_flag: '0',
      },
      items: [
        {
          label: '全員配信',
          name: 'filter_obj_flag',
          options: [
            { label: 'ON', value: '0' },
            { label: 'OFF', value: '1' },
          ],
          rules: {
            required: false,
          },
        },
      ],
    }
  },
  computed: {
    add() {
      return this.type === 'add'
    },
    view() {
      return this.type === 'view'
    },
    edit() {
      return this.type === 'edit'
    },
    isHideEditComputed() {
      return (
        this.add ||
        this.notificationDetail.status !== 0 ||
        !FULL_ROLE_AGENT_EDIT.includes(this.currentUser.level)
      )
    },
  },
  watch: {
    notificationDetail() {
      const filterObj = this.notificationDetail.filter_obj || null
      const data = {
        filter_obj: filterObj,
        filter_obj_flag: filterObj != null ? '1' : '0',
      }
      if (!this.dataInit) {
        this.dataInit = {}
      }
      this.data = cloneDeep(data)
    },
    data: {
      handler() {
        if (JSON.stringify(this.data) !== JSON.stringify(this.dataInit)) {
          this.dataInit = cloneDeep(this.data)
          this.$emit('change', this.data)
        }
      },
      deep: true,
    },
    type() {
      if (this.type === 'view') {
        this.editable = false
      } else if (this.type === 'edit') {
        this.editable = true
      }
    },
  },
  created() {},
  methods: {
    handleChangeDeliveryTarget(key, value) {
      const data = this.data
      if (value === '1') {
        data.filter_obj = {
          gender: 2,
          age_range_lower: null,
          age_range_upper: null,
          last_measure_date_lower: null,
          last_measure_date_upper: null,
          weight_differ_lower: null,
          weight_differ_upper: null,
          body_fat_rate_differ_lower: null,
          body_fat_rate_differ_upper: null,
          weight_range: null,
          body_fat_rate_range: null,
          body_water_rate_range: null,
          BMR_range: null,
          metabolic_age_range: null,
          muscle_rate_range: null,
          bone_mass_range: null,
          subcutaneous_fat_range: null,
          visceral_fat_range: null,
          BMI_range: null,
          muscle_mass_range: null,
          protein_range: null,
          member_status: null,
          admin_note: null,
          answer1: null,
          answer2: null,
          answer3: null,
          answer4: null,
        }
      } else {
        data.filter_obj = null
      }
      data.filter_obj_flag = value
      this.data = data
    },
    changeDeliveryTargetFilterObj(filterObj) {
      const data = this.data
      data.filter_obj = filterObj
      this.data = { ...data }
    },
    toggleEditable() {
      this.editable = !this.editable
      this.$emit('enable:edit', this.editable)
    },
    handleSubmit() {
      const data = this.data
      this.$emit('edit:notification', data)
    },
  },
}
</script>

<template>
  <div id="notification_agentadmin-delivery-target">
    <BaseCardDetail
      title="配信対象"
      form-collapsed
      :errors="errors"
      :trigger-mask="!editable && triggerMask"
      :has-footer="!add && editable"
      @edit="toggleEditable"
      @cancel="toggleEditable"
      @submit="handleSubmit"
    >
      <template v-if="isHideEditComputed" v-slot:header-action>
        <div />
      </template>
      <CRow
        v-for="item in items"
        :key="item.key"
        class="d-flex align-items-baseline flex-wrap"
      >
        <CCol sm="3">
          <div class="col-form-label">
            {{ item.label }}
            <span v-if="item.rules && item.rules.required" class="text-danger">
              *
            </span>
          </div>
        </CCol>
        <CCol sm="9">
          <template v-if="item.name === 'filter_obj_flag'">
            <BaseRadioGroup
              :checked="data[item.name]"
              inline
              custom
              :options="item.options"
              :disabled="view"
              @update:checked="
                (v) => {
                  handleChangeDeliveryTarget(item, v)
                }
              "
            />
          </template>
          <template v-if="item.name === 'filter_obj_flag'">
            <label class="small">OFFの場合は、条件を指定してください</label>
            <div v-if="data[item.name] === '1'" class="form-group">
              未入力または未選択の場合は絞り込み対象となりません
            </div>
          </template>
        </CCol>
      </CRow>
      <DeliveryTargetFilterObj
        v-if="data.filter_obj !== null"
        :filter-obj="data.filter_obj"
        :type="type"
        @change="changeDeliveryTargetFilterObj"
      />
    </BaseCardDetail>
  </div>
</template>

<style lang="scss" scoped>
#notification_agentadmin-delivery-target {
  ::v-deep .form-group {
    /* margin-bottom: 2rem; */
  }
}
</style>
